import { DSNCSeeAlso } from 'shared-definitions/types'
import { ApiComponentRelatedArticles } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function ncRelatedArticles(
  input: ApiComponentRelatedArticles,
  opts: PLinkMapperOpts
): DSNCSeeAlso[] {
  return input.posts.map(item => ({
    resource: 'nc-see-also',
    layout: 'default',
    overrideTheme: 'inherit',
    title: input.title,
    text: null,
    subtitle: 'Related',
    image: imageMapper(item.image, opts),
    pLink: pLinkMapper('url' in item ? item.url : item.slug, opts),
  }))
}
